import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";

const SearchableDropDown = ({
    label,
    name,
    value,
    placeholder,
    options,
    isRequired,
    onChange,
    errormsg,
    isDisabled,
    permissionFields = {},
    fieldKey,
    fieldFlag,
    customStyles,
    menuShouldScrollIntoView = false,
    error = false,
    fieldName,
    isLoading,
}) => {
    const [loadingDRP, setLoadingDRP] = useState(false)
    useEffect(() => {
        if (Array.isArray(options)) {
            setLoadingDRP(false); // stop loading once we receive an array (even an empty one)
        } else {
            setLoadingDRP(true); // keep loading if options is null or undefined
        }
    }, [options]);
    const safeOptions = Array.isArray(options) ? options : [];


    const canView =
        !fieldKey ||
        !permissionFields?.hasOwnProperty(fieldKey) ||
        permissionFields?.[fieldKey]?.canView;

    if (!canView) return null;



    return (
        <>
            {label && (
                <label htmlFor={fieldName}>
                    {label}
                    {isRequired && <span className="required-star" style={{ color: "red" }}>*</span>}
                </label>
            )}

            <Select
                value={value}
                onChange={(selected) => onChange(selected, fieldName)}
                options={safeOptions}
                menuShouldScrollIntoView={false}
                isDisabled={isDisabled}
                placeholder={placeholder}
                menuPortalTarget={document.body}
                isLoading={loadingDRP}
                styles={{
                    container: (base) => ({
                        ...base,
                        width: "100%",
                    }),
                    control: (base, state) => ({
                        ...base,
                        borderRadius: "5px",
                        borderColor: error
                            ? "red"
                            : state.isFocused
                                ? "#456ABB"
                                : base.borderColor,
                        borderWidth: "1px",
                        boxShadow: state.isFocused
                            ? "0 0 5px rgba(0, 86, 179, 0.3)"
                            : "none",
                        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                            borderColor: "#456ABB",
                        },
                    }),
                    placeholder: (base, state) => ({
                        ...base,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        color: state?.isDisabled ? "#505050" : base.color,
                        fontSize: state?.isDisabled ? "1rem" : "0.8rem",
                        fontWeight: state?.isDisabled ? "500" : "400",
                    }),
                    menu: (base) => ({
                        ...base,
                        borderRadius: "5px",
                        zIndex: 999999,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 999999,
                    }),
                    option: (base, state) => ({
                        ...base,
                        backgroundColor: state.isSelected
                            ? "#C2DBFF"
                            : state.isFocused
                                ? "#fff"
                                : "white",
                        color: "#222",
                        cursor: "pointer",
                        transition: "background-color 0.2s ease",
                        fontSize: "0.8rem",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                    }),
                }}
            />
            {errormsg && (
                <div style={{ color: "red", fontSize: "0.75rem", marginTop: "0.25rem" }}>
                    {errormsg}
                </div>
            )}
        </>
    );
};

export default SearchableDropDown;
